// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_MRb","content":"styles_content__3QexI","tableWrap":"styles_tableWrap__Ga-Rx"};